import React from "react"

// Small amber pill marking a shop flagged as a development store (doc 06).
// Shown wherever a dev store is visible despite being excluded from reports
// by default — the Customers list (with show_dev on) and the detail page.
export function DevStoreBadge({ label }) {
  return (
    <span className="inline-flex items-center rounded-full bg-amber-50 dark:bg-amber-950/40 px-2 py-0.5 text-xs font-medium text-amber-700 dark:text-amber-300 ring-1 ring-inset ring-amber-600/20">
      {label}
    </span>
  )
}
